import { useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"
import {
	setOptimizeData,
	resetAllEdits
} from "../../features/schedule/scheduleSlice"
import { setSandboxOptimizeData } from "../../features/schedule/sandboxSlice"
import useLogging from "../useLogging"
import useScheduleFromBackend from "./useScheduleFromBackend"

const useFetchSchedules = (componentName = "default") => {
	const dispatch = useDispatch()
	const logging = useLogging()
	const {
		data: scheduleData,
		isLoading,
		error,
		refetch: refetchSchedule
	} = useScheduleFromBackend(componentName)

	const isEditing = useSelector(state => state.schedule.isEditing)

	const editedPatients = useSelector(state => state.schedule.editedPatients)
	const editedNurses = useSelector(state => state.schedule.editedNurses)

	const sandboxSchedule = useSelector(state => state.sandbox)

	useEffect(() => {
		if (!scheduleData) {
			return
		}

		if (isEditing) {
			return
		}
		
		dispatch(setOptimizeData(scheduleData))

		//If the editedPatients or editedNurses are not set, set them
		if (!editedPatients.length || !editedNurses.length) {
			logging.info("setting edited patients")
			logging.info("setting edited nurses")
			dispatch(resetAllEdits())
		}

		if (sandboxSchedule.documentId === null) {
			dispatch(setSandboxOptimizeData(scheduleData))
		}
		// Intentionally only re-runs when scheduleData changes. The other
		// reactive values (isEditing, editedNurses/editedPatients lengths,
		// sandboxSchedule.documentId) are guards read at the moment the new
		// scheduleData arrives — adding them as deps would clobber in-progress
		// edits whenever the user toggles edit mode or accumulates edits.
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [scheduleData])

	return { isLoading, error, refetch: refetchSchedule }
}

export default useFetchSchedules
